import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContractChangeExtendPeriodWidget from '../../../widgets/contractChangeExtendPeriod/ContractChangeExtendPeriodWidget'
import { getprojectInfo } from '../../../redux/actions/projectOverview'
import { contractExtendPeriodForm } from '../../../redux/actions/contractExtendPeriod'

export default function ContractChangeExtendPeriod() {
  const [schema, setSchema] = useState()
  const [projectInfo, setProjectInfo] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const projectId = sessionStorage.getItem('projectId')
  const contractChangeId = sessionStorage.getItem('param')?.replace('?', '')

  useEffect(() => {
    if (projectId) {
      handleGetprojectInfoSchema(projectId)
      handleGetSchema(projectId)
    }
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await contractExtendPeriodForm(projectVersionId, contractChangeId)
      // console.log('response => ', response)
      setSchema(response)
      // console.log('mock => ', mock)
      // setSchema(mock)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetprojectInfoSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getprojectInfo(projectVersionId)
      if (response?.model) {
        setProjectInfo(response.model)
      }
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeaderWidget header={schema?.header} subHeader={schema?.subHeader} />
        {projectInfo && (
          <div style={{ marginBottom: 10 }}>
            <ProjectBasicInfo schema={projectInfo} />
          </div>
        )}

        {schema.forms.extendPeriod && (
          <div style={{ marginBottom: 10 }}>
            <ContractChangeExtendPeriodWidget schema={schema.forms.extendPeriod} />
          </div>
        )}
      </SidebarProposal>
    </>
  )
}
